module.exports = __webpack_public_path__ + "img/gcp.92c9d851.svg";